import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TransactionStatusListComponent } from './transaction-status-list/transaction-status-list.component';

const routes: Routes = [
  {path:'transactionsStatus', component: TransactionStatusListComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionStatusRoutingModule { }
